.ej{gap:0.25rem;}